import './App.css';
import React from 'react'
import AppTestScreen from './AppTestScreen'

function App() {
	return (
		<React.Fragment>
			<div className="App">
				<AppTestScreen />
			</div>
		</React.Fragment>
	);
}

export default App;
